module.exports = "<h1>About the Model</h1>\r\n\r\n<p>Mobius v0.7.38</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/help/info-viewer/help.model.tpl.html
// module id = ../../../../../src/app/ui-components/help/info-viewer/help.model.tpl.html
// module chunks = main